const r = {
  initial: "0px 2px 16px 0px rgba(0, 0, 0, 0.10)",
  hover: "0px 8px 16px 0px rgba(0, 0, 0, 0.30)"
}, a = {
  initial: "0px 2px 16px 0px rgba(0, 0, 0, 0.25)",
  hover: "0px 8px 16px 0px rgba(0, 0, 0, 0.75)"
};
var p = /* @__PURE__ */ ((x) => (x.INITIAL = "initial", x.HOVER = "hover", x))(p || {});
export {
  p as ShadowTypeEnum,
  a as shadowsDark,
  r as shadowsLight
};
